export const dialog = {
  root: {
    class: 'w-full h-full tablet:w-11/12 tablet:h-auto tablet:max-h-[90vh] xl:w-2/3',
  },
  content: {
    class: 'h-full p-0 bg-stone-300 tablet:h-auto tablet:max-h-[calc(90vh-4rem)] tablet:overflow-y-auto',
  },
  header: {
    class: 'bg-gray-800 text-white p-3',
  },
  footer: {
    class: 'bg-gray-800 text-white p-0',
  },
}
